<template>
  <div class="affiliate-custom-widgets">
    <SupportInfo v-if="contactInfoEnabled" />
    <PoweredByLendio v-if="poweredByLendioEnabled" />
  </div>
</template>
<script>
import PoweredByLendio from '~/components/PoweredByLendio.vue';
import SupportInfo from '~/components/SupportInfo.vue';
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { mapState } from 'pinia';

export default {
  name: 'AffiliateCustomSidebarWidgets',
  components: {
    SupportInfo,
    PoweredByLendio
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'poweredByLendioEnabled',
      'contactInfoEnabled'
    ]),
  }
}
</script>
<style lang="scss" scoped>

.affiliate-custom-widgets {
  display: flex;
  flex-direction: column;
}
</style>
